import { render, staticRenderFns } from "./AlumniStories.vue?vue&type=template&id=521e2df0&scoped=true"
import script from "./AlumniStories.vue?vue&type=script&lang=js"
export * from "./AlumniStories.vue?vue&type=script&lang=js"
import style0 from "./AlumniStories.vue?vue&type=style&index=0&id=521e2df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521e2df0",
  null
  
)

export default component.exports